/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-template-curly-in-string */
import Config from 'app.config';
import {
  compact,
  filter,
  get,
  includes,
  isEmpty,
  map,
  size,
  sortBy,
  words,
} from 'lodash-es';
import queryString from 'query-string';
import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import ReactPaginate from 'react-paginate';
import { connect } from 'react-redux';
import { Link, NavLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import injectSaga from 'utils/injectSaga';
import BottomCurve from '../../components/BottomCurve';
import ClipText from '../../components/ClipText';
import FooterGetApp from '../../components/FooterGetApp';
import HeroButton from '../../components/HeroButton';
import HowItWorks from '../../components/HowItWorks';
import LoadingScreen from '../../components/LoadingIndicator';
import PageHeading from '../../components/PageHeading';
import SectionContainer from '../../components/SectionContainer';
import SqzBenefits from '../../components/SqzBenefits';
import SqzText from '../../components/SqzText';
import StripesHeader from '../../components/StripesHeader';
import SvgIcon from '../../components/SvgIcon';
import TherapistRating from '../../components/TherapistRating';
import {
  CANONICAL_URL,
  FRANCHISE_PHASES,
  PHASES,
  analytics,
  genderMap,
  locationsInfoMapLink,
  slugGenerator,
} from '../../utils/common';
import reCaptchaV3Plugin from '../../utils/third-party-plugins/recaptcha-v3';
import Footer from '../Footer';
import Header from '../Header';
import { setSelectedMembershipType } from '../Membership/actions';
import MemershipDetails from '../Membership/membership-details';
import MemershipBenefits from '../Membership/membership_benefits';
import { fetchTherapists } from '../Therapist/actions';
import TherapistFilter from '../Therapist/filter';
import therapistSaga from '../Therapist/saga';
import makeSelectTherapist from '../Therapist/selectors';
import { makeSelectUser } from '../User/selectors';
import {
  fetchLocationServices,
  fetchMassageTypes,
  setBookingFlow,
  setSelectedLocation,
  setSelectedService,
} from './actions';
import FranchisePhase1 from './franchise_phases/phase1';
import FranchisePhase3 from './franchise_phases/phase3';
import LocationReviews from './location-reviews';
import Map from './map';
import saga from './saga';
import makeSelectAppointment from './selectors';
import '../../css/therapist-picker.css';

const therapistsAtOnce = 5;

class LocationInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      therapists: [],
      filteredTherapists: [],
      fetchingTherapists: true,
      therapistOffset: 0,
      isPreLive:
        get(queryString.parse(this.props.location.search), 'prelive') ===
        'true',
    };
    this.paginateTherapists = this.paginateTherapists.bind(this);
    this.handleTherapistFilter = this.handleTherapistFilter.bind(this);
    this.handleBookNow = this.handleBookNow.bind(this);
    this.renderLocationAddress = this.renderLocationAddress.bind(this);
  }

  renderReviews() {
    return <LocationReviews therapists={[...this.state.therapists]} />;
  }

  handleBookNow(location) {
    this.props.setSelectedLocation(location);
    this.props.setBookingFlow('locations');
    this.props.history.push(
      `/appointment/location/${location.id}/services/${slugGenerator(
        location.url_name,
      )}`,
    );
    this.paginateTherapists = this.paginateTherapists.bind(this);
  }

  componentDidMount() {
    reCaptchaV3Plugin('location_info_page');
    const { isPreLive } = this.state;
    this.props.setSelectedMembershipType({});
    const locationId = get(this.props, 'computedMatch.params.locationId');
    const locationName = get(this.props, 'computedMatch.params.locationName');

    if (isPreLive) {
      localStorage.setItem(`${locationName}-preLive`, isPreLive);
    }
    const authToken = localStorage.getItem('userToken');
    this.props.fetchLocationServices(locationId, !isEmpty(authToken));
    this.props.fetchTherapists(locationId);
    this.props.fetchMassageTypes();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      fetchingTherapists,
      fetchingTherapistsError,
      therapists,
    } = nextProps.therapistData;
    if (
      !fetchingTherapists &&
      !fetchingTherapistsError &&
      prevState.fetchingTherapists
    ) {
      const sortedTherapists = sortBy(therapists, ['first_name', 'last_name']);

      return {
        fetchingTherapists,
        therapists: sortedTherapists,
        filteredTherapists: sortedTherapists,
      };
    }
    return { fetchingTherapists };
  }

  handleTherapistFilter({ gender, pregnancyPreference, searchVal }) {
    const { therapists } = { ...this.state };

    let filteredTherapists;

    // filter gender
    filteredTherapists = filter(
      therapists,
      t => (isEmpty(gender) ? true : t.gender === genderMap[gender]),
    );

    // filter prenatal
    filteredTherapists = filter(
      filteredTherapists,
      t => (!pregnancyPreference ? true : Number(t.pregnancy) === 1),
    );

    // filter on search query
    const query = map(compact(words(searchVal)), val => val.toLowerCase());

    filteredTherapists = filter(
      filteredTherapists,
      therapist =>
        // eslint-disable-next-line no-nested-ternary
        isEmpty(query)
          ? true
          : size(query) > 1
            ? includes(
                therapist.first_name && therapist.first_name.toLowerCase(),
                query[0],
              ) &&
              includes(
                therapist.last_name && therapist.last_name.toLowerCase(),
                query[1],
              )
            : includes(
                therapist.last_name && therapist.last_name.toLowerCase(),
                query[0],
              ) ||
              includes(
                therapist.first_name && therapist.first_name.toLowerCase(),
                query[0],
              ),
    );
    this.setState({
      filteredTherapists,
      therapistOffset: 0,
    });
  }

  paginateTherapists(data) {
    this.setState({
      therapistOffset: Math.ceil(data.selected * therapistsAtOnce),
    });
  }

  renderLocationTherapists() {
    const { locationServices, massageTypes } = this.props.appointmentData;
    const {
      fetchingTherapists,
      fetchingTherapistsError,
    } = this.props.therapistData;
    const { filteredTherapists, therapists, therapistOffset } = this.state;

    if (fetchingTherapists || isEmpty(therapists)) {
      return <LoadingScreen hangTight="true" />;
    } else if (fetchingTherapistsError) {
      return <div>We are unable to load the therapists</div>;
    }
    return (
      <div className="location-details__therapists">
        <StripesHeader>
          THERAPISTS AT{' '}
          {locationServices.name && locationServices.name.toUpperCase()}
        </StripesHeader>

        {massageTypes && (
          <TherapistFilter
            pregnancyToggle={[{ id: 1, name: 'Yes' }, { id: 0, name: 'No' }]}
            therapists={therapists}
            handleFilter={filterParams =>
              this.handleTherapistFilter(filterParams)
            }
          />
        )}
        {isEmpty(filteredTherapists) && (
          <div className="location-deatils__no-therapists">
            <div>
              {"We're"} sorry, we {"can't"} find anyone by that name.
            </div>
            <div>(Are you sure you spelled it correctly?)</div>
          </div>
        )}
        {!isEmpty(filteredTherapists) && (
          <div className="location-details__available-therapists">
            {filteredTherapists
              .slice(therapistOffset, therapistsAtOnce + therapistOffset)
              .map(therapist => (
                <article
                  className="location-details__therapist-item therapist-item__item locationInfoTherapistDetailsList MoreInfoLoc"
                  key={therapist.id}
                >
                  <div>
                    <p className="therapist-item__name">
                      {`${therapist.first_name}`}
                    </p>
                  </div>
                  <div>
                    <div className="therapist-item__rating">
                      <TherapistRating therapist={therapist} />
                    </div>
                    <Link
                      className="btn moreInfoButtons"
                      to={`/therapist/${therapist.id}/info/book`}
                      onClick={() => {
                        analytics(
                          'Choose Therapist',
                          {
                            Location_Name: locationServices.city,
                            Therapist_Name: `${
                              therapist.first_name
                            } ${therapist.last_name &&
                              therapist.last_name.charAt(0)}`,
                          },
                          true,
                        );
                      }}
                    >
                      Select
                    </Link>
                  </div>
                </article>
              ))}
          </div>
        )}
        {!isEmpty(filteredTherapists) && (
          <ReactPaginate
            previousLabel="<"
            nextLabel=">"
            breakLabel={
              <a aria-label="location-info-break-label" href="/#">
                ...
              </a>
            }
            breakClassName="break-me"
            pageCount={Math.ceil(filteredTherapists.length / therapistsAtOnce)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={1}
            onPageChange={this.paginateTherapists}
            containerClassName="form-list"
            subContainerClassName="pages pagination"
            activeClassName="active bold"
          />
        )}
      </div>
    );
  }

  renderLocationServices(locationServices) {
    return (
      <tbody>
        {locationServices.services.map(service => (
          <tr className="location-info__services-tbl-row" key={service.id}>
            <td className="location-info__services-tbl-cell location-info__services-tbl-cell--first">
              <span>{service.title} Squeeze </span>
              <span>({service.duration}-Min Massage)</span>
            </td>
            <td className="location-info__services-tbl-cell location-info__services-tbl-cell--dark">
              ${service.member_price}
              <sup>*</sup>
            </td>
            <td className="location-info__services-tbl-cell">
              ${service.non_member_price}
            </td>
          </tr>
        ))}
      </tbody>
    );
  }

  renderMembershipSubscription(locationServices) {
    const isPhase3 = locationServices.launch_status !== FRANCHISE_PHASES.PHASE3;
    return isPhase3 ? (
      <span>
        {' '}
        Learn More{' '}
        <a
          aria-label="membership-location-learn-more"
          href="/membership"
          onClick={() =>
            analytics('Individual Location - Learn More', null, true)
          }
        >
          here.
        </a>
      </span>
    ) : (
      ''
    );
  }

  renderLocationAddress(urlName, city, state) {
    if (urlName === 'alamoheights') {
      return `SAN ANTONIO, ${state}`;
    }
    return `${city}, ${state}`;
  }

  renderMap(locationServices) {
    const { isPreLive } = this.state;
    return (
      <div>
        <StripesHeader>
          {this.renderLocationAddress(
            locationServices.url_name,
            locationServices.city,
            locationServices.state,
          )}
        </StripesHeader>
        <div className="location-details__desc phone-only">
          <ClipText text={locationServices.description} clipLength={140} />
        </div>
        <div className="location-details__desc hide-phone">
          {locationServices.description}
        </div>
        <div className="location-info__wrapper">
          <div id="mapName" className="location-info__map">
            {window.google && (
              <Map
                locations={[locationServices]}
                googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${
                  Config.googleMapsApiKey
                }&v=3.exp&libraries=geometry,drawing,places`}
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={
                  <div className="locationConfigs-list__component" />
                }
                mapElement={
                  <div className="ir locations-list-map__ir_moreInfo" />
                }
                handleLocationClick={this.handleLocationClick}
              />
            )}
          </div>
          <div className="location-info__details ">
            <h3 className="location-info__location-name">
              Squeeze {locationServices.name}
            </h3>
            <div className="location-info__address">
              <div className="location-info__adress-item">
                <a
                  aria-label="location-location-details"
                  href={locationsInfoMapLink(locationServices)}
                  target="_blank"
                  onClick={() => {
                    analytics(
                      'Individual Location - Get Directions',
                      { Address: locationServices.address },
                      true,
                    );
                  }}
                >
                  {locationServices.address &&
                    locationServices.address.split(',')[0]}
                  <div className="location-info__adress-item">
                    {`${locationServices.city}, ${locationServices.state} ${
                      locationServices.zip
                    }`}
                    <SvgIcon
                      icon="location-pointer"
                      className="xs locationPointerIcon"
                    />
                  </div>
                </a>
              </div>
            </div>
            <div className="location-info__hours">{locationServices.hours}</div>
            {(locationServices.is_active || isPreLive) &&
            locationServices.launch_status !== FRANCHISE_PHASES.PHASE3 ? (
              <div className="location-info__book">
                <button
                  className="btn btn--secondary"
                  type="button"
                  name="button"
                  onClick={() => {
                    this.handleBookNow(locationServices);
                    analytics(
                      'Book Here',
                      { 'Location Name': locationServices.city },
                      true,
                    );
                  }}
                >
                  Book Here
                </button>
              </div>
            ) : (
              ''
            )}
            <div className="location-info__services">
              <table className="location-info__services-tbl">
                <thead>
                  <tr>
                    <th className="location-info__services-tbl-hdr location-info__services-tbl-hdr--first">
                      Services
                    </th>
                    <th className="location-info__services-tbl-hdr">
                      Member Rate
                    </th>
                    <th className="location-info__services-tbl-hdr">
                      Pay-Per-Squeeze
                    </th>
                  </tr>
                </thead>
                {!isEmpty(locationServices) &&
                  this.renderLocationServices(locationServices)}
              </table>
              <div className="location-info__services-tbl-ftr locationInfotableFooter">
                <sup>*</sup>
                <span>
                  With Membership subscription.
                  {this.renderMembershipSubscription(locationServices)}
                </span>
              </div>
              <a
                aria-label="squeeze-zendesk"
                className="moreInfoHelpCenterLink"
                target="_blank"
                href="https://squeezemassage.zendesk.com/hc/en-us"
              >
                Questions? Check out our <span>Help Center</span>.
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLocationMap(locationServices) {
    return (
      <div>
        <SectionContainer>
          <div className="locations locations__container mt60">
            <div className="location-details__component">
              {this.renderMap(locationServices)}
              {this.renderLocationTherapists()}
            </div>
          </div>
        </SectionContainer>
      </div>
    );
  }

  render() {
    const {
      fetchingLocationServices,
      fetchingLocationServicesError,
      locationServices,
    } = this.props.appointmentData;
    const { services } = locationServices;

    if (fetchingLocationServices) {
      return <LoadingScreen hangTight="true" />;
    } else if (fetchingLocationServicesError) {
      return <div>{fetchingLocationServicesError}</div>;
    }

    const CITY = locationServices.city;
    const pageTitle = `Massage Therapy Near By | ${CITY} | Squeeze Massage`;
    const urlNameRoute = window.location.pathname.split('/').pop();

    return (
      <Fragment>
        <div className="appWrap">
          <div className="MainContentWrap location_main_wrap">
            <Helmet titleTemplate="%s - Squeeze" defaultTitle="Squeeze">
              <title>{pageTitle}</title>
              <link
                rel="canonical"
                href={`${CANONICAL_URL}/${this.props.location.pathname}`}
              />
              <meta
                name="description"
                content={`Use our app to save your massage preferences to your profile so your therapist knows what you want, each time! Book today at our ${
                  locationServices.city
                }!`}
              />
            </Helmet>
            <Header
              showCloseButton={false}
              showBackButton={false}
              showHamburgerMenu
            />
            <div>
              {locationServices &&
              FRANCHISE_PHASES.PHASE1 === locationServices.launch_status ? (
                <div>
                  <FranchisePhase1 locationServices={locationServices} />
                  <div className="locations locations__container location-sec">
                    <div>
                      <HowItWorks showFooter />
                    </div>
                  </div>
                </div>
              ) : FRANCHISE_PHASES.PHASE2 === locationServices.launch_status ? (
                <div className="phase-3">
                  <section className="hero locationNash hero-main">
                    <div className="hero__bg">
                      <div className="container">
                        <PageHeading>
                          WIN THREE MONTHS OF SQUEEZIN’ WE’RE NOT TEASIN’!
                        </PageHeading>
                        <SqzText addClass="smallFontHowItWork ucase phone-only hiwHeader">
                          WIN THREE MONTHS OF SQUEEZIN’ WE’RE NOT TEASIN’!
                        </SqzText>
                        <iframe
                          frameBorder="0"
                          src={`https://app.viralsweep.com/sweeps/widget/${
                            Config[
                              urlNameRoute ||
                                locationServices.url_name.toLowerCase()
                            ]
                          }?framed=1`}
                        >
                          Not Supported
                        </iframe>
                      </div>
                      <HeroButton foundingMembership />
                      <BottomCurve />
                    </div>
                  </section>
                  <div className="locations locations__container location-sec">
                    <div>
                      <HowItWorks showFooter />
                    </div>
                  </div>
                </div>
              ) : FRANCHISE_PHASES.PHASE3 === locationServices.launch_status ? (
                <div className="phase-3 phaseLoc">
                  <FranchisePhase3
                    fetchLocationServices={this.props.fetchLocationServices}
                    locationServices={locationServices}
                  />
                  <div className="container text-center mt40">
                    <MemershipBenefits phase3 />
                    <MemershipDetails phase3 />
                  </div>
                  <div
                    className="locations location-sec container"
                    id="phase-3"
                  >
                    {this.renderMap(locationServices)}
                    <div>
                      <HowItWorks showFooter phase3 />
                    </div>
                  </div>
                </div>
              ) : (
                this.renderLocationMap(locationServices)
              )}
            </div>
            <section className="home-join home-join-location">
              <div className="container">
                <div className="select-service__line noPaddingLine">
                  <i className="icon icon--squiggle" />
                </div>
                <ul className="c-values-list list-reset">
                  {FRANCHISE_PHASES.PHASE3 !==
                    locationServices.launch_status && (
                    <li className="c-values-item pt50">
                      <div className="c-values-item__image moreInfoExtraInfo">
                        <img
                          alt="more-info-1"
                          src={`${Config.awsCloudFrontUrl}/svg/moreInfo-1.svg`}
                        />
                      </div>

                      <div className="c-values-item__content">
                        <h4 className="c-values-item__hdg MORE-SQUEEZE-LESS-F">
                          <span>MORE SQUEEZE, </span>
                          LESS FEES
                        </h4>
                        <p className="c-values-item__desc More-info-para">
                          Choose from two membership options. The Mid-Squeeze
                          gets you one 50-min massage each month for only ${!isEmpty(
                            services,
                          )
                            ? services[1].member_price
                            : 95}{' '}
                          and the Main Squeeze gets you one 80-min massage each
                          month for just ${!isEmpty(services)
                            ? services[0].member_price
                            : 125}, and both allow you to book additional
                          massages at discounted member rates. Plus, each
                          massage includes your choice of deep tissue, heat
                          therapy, percussion therapy, and aromatherapy at no
                          additional charge!
                        </p>
                        <Link
                          className="btn moreInfoButtons locationInfoDetailBtn"
                          to="/membership"
                        >
                          Learn More
                        </Link>
                      </div>
                    </li>
                  )}

                  <li className="c-values-item">
                    <div className="c-values-item__image moreInfoExtraInfo">
                      <img
                        alt="more-info-2"
                        src={`${Config.awsCloudFrontUrl}/svg/moreInfo-2.svg`}
                      />
                    </div>
                    <div className="c-values-item__content">
                      <h4 className="c-values-item__hdg MORE-SQUEEZE-LESS-F">
                        HAVE A FRIEND IN <span>KNEAD?</span>
                      </h4>
                      <p className="c-values-item__desc More-info-para">
                        Give the gift of Squeeze! There are three ways to spread
                        the love and relaxation. You can gift someone a single
                        massage, a monthly membership, or Squeeze Bucks, which
                        allows you to choose a custom amount that’s good toward
                        any service.
                      </p>
                      <Link
                        className="btn moreInfoButtons locationInfoDetailBtn"
                        to="/gift"
                        onClick={() =>
                          analytics(
                            'Individual Location - Gift Cards',
                            null,
                            true,
                          )
                        }
                      >
                        Gift Cards
                      </Link>
                    </div>
                  </li>

                  <li className="c-values-item pb20">
                    <div className="c-values-item__image moreInfoExtraInfo">
                      <img
                        alt="more-info-3"
                        src={`${Config.awsCloudFrontUrl}/svg/moreInfo-3.svg`}
                      />
                    </div>
                    <div className="c-values-item__content">
                      <h4 className="c-values-item__hdg MORE-SQUEEZE-LESS-F">
                        JOIN THE <span>SQUEEZE SQUAD</span>
                      </h4>
                      <p className="c-values-item__desc More-info-para">
                        We’ve got your back! At Squeeze, our team’s wellness
                        comes first, so we offer tons of perks like health
                        benefits, paid vacation, flexible schedules, and oh
                        yeah, a free monthly massage!
                      </p>
                      {/* <button className="btn moreInfoButtons locationInfoDetailBtn">
                    Join Us
                  </button> */}
                      <Link
                        className="btn moreInfoButtons locationInfoDetailBtn"
                        to="/careers"
                        onClick={() =>
                          analytics('Individual Location - Join Us', null, true)
                        }
                      >
                        Join Us
                      </Link>
                    </div>
                  </li>
                </ul>

                {locationServices.is_active ? <SqzBenefits /> : ''}
                {this.renderReviews()}
              </div>
            </section>

            <section className="home-join home-join-location">
              <div className="container">
                <StripesHeader>ABOUT SQUEEZE</StripesHeader>
                <p className="aboutSqueezeMoreInfo">
                  Squeeze is a way better massage experience from the founders
                  of Drybar. So, why did we start a massage business? Because we
                  love making people feel good. And, we love massages (who
                  doesn’t?!). But, we found ourselves frustrated with the
                  options out there: either mediocre discount establishments or
                  overpriced spas ($250 for a massage? No, thank you!). Not to
                  mention hard-to-book appointments, awkward checkout counters
                  and massages that were never the right pressure. So, we built
                  the brand and massage experience we longed for. We hope you’ll
                  love it as much as we do. Squeeze ya soon! Xoxo
                </p>
                <FooterGetApp />
              </div>
            </section>
            {!PHASES.includes(locationServices.launch_status) && (
              <div className="phone-only bookMassageBtnMobile">
                <NavLink
                  aria-label="book-massage"
                  to="/appointment/locations"
                  id="bookMassage-from-location-info"
                  className="btn"
                >
                  Book A Massage
                </NavLink>
              </div>
            )}
          </div>
          <div className="FootContentWrap">
            <Footer />
          </div>
        </div>
      </Fragment>
    );
  }
}

LocationInfo.propTypes = {
  appointmentData: PropTypes.object,
  history: PropTypes.object,
  therapistData: PropTypes.object,
  location: PropTypes.object,
  fetchMassageTypes: PropTypes.func,
  setSelectedLocation: PropTypes.func,
  setBookingFlow: PropTypes.func,
  setSelectedMembershipType: PropTypes.func,
  fetchLocationServices: PropTypes.func,
  fetchTherapists: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  appointmentData: makeSelectAppointment(),
  therapistData: makeSelectTherapist(),
  user: makeSelectUser(),
});

const withSagaFetchMassageTypes = injectSaga({
  key: 'fetchMassageTypes',
  saga: saga.watchFetchMassageTypes,
});

const withSagaFetchTherapists = injectSaga({
  key: 'fetchTherapists',
  saga: therapistSaga.watchFetchTherapists,
});

const withSagaFetchLocationServices = injectSaga({
  key: 'fetchLocationServices',
  saga: saga.watchFetchLocationServices,
});

const withConnect = connect(
  mapStateToProps,
  {
    fetchLocationServices,
    fetchTherapists,
    fetchMassageTypes,
    setSelectedLocation,
    setSelectedService,
    setBookingFlow,
    setSelectedMembershipType,
  },
);

export default compose(
  withRouter,
  withConnect,
  withSagaFetchLocationServices,
  withSagaFetchTherapists,
  withSagaFetchMassageTypes,
)(LocationInfo);
